import {
  CompositeConditionDefinition,
  Control,
  EntityMetadata,
  FieldDefinition,
  FormNode,
  GenericFieldValue,
  OperatorNames,
  OperatorType,
  OptionsetFieldDefinition,
  SimpleConditionDefinition,
  ViewModel,
} from '@msdk/definitions'

import { getFieldDefIncludeExternal } from '../../../utils'
import { FilterItem } from './filter-item'

function enancheFieldDefForOperator(fieldDef: FieldDefinition, operator: OperatorNames): FieldDefinition {
  const fieldDefCloned = {
    ...fieldDef,
  }

  if (fieldDef.fieldDefinitionType === 'OptionSet') {
    // eslint-disable-next-line @typescript-eslint/no-extra-semi
    ;(fieldDefCloned as OptionsetFieldDefinition).multipleSelection = operator === 'In'
  }

  return fieldDefCloned as FieldDefinition
}

export function createFormNodeForFilter(
  fieldDef: FieldDefinition,
  viewName: string,
  value?: GenericFieldValue,
  operator?: OperatorNames,
): FormNode {
  let fieldDefEnanched = fieldDef

  if (operator) {
    fieldDefEnanched = enancheFieldDefForOperator(fieldDef, operator)
  }

  return {
    id: 'FILTER_NODE',
    value: {
      entityName: fieldDef.entityName,
      data: value,
      fieldDefinition: fieldDefEnanched,
      formDefinition: { formName: viewName } as any,
      isDirty: false,
      state: 'Enabled',
      visibility: 'Visible',
      type: fieldDef.fieldDefinitionType,
      validationMessages: [],
      validationParams: [],
      validationState: 'Valid',
      validationFlags: 0,
    } as Control,
  }
}

export function conditionsToFilters(
  viewModel: ViewModel,
  condition: CompositeConditionDefinition,
  baseMetadata: EntityMetadata,
): FilterItem[] {
  const res: FilterItem[] = []
  const conditions = condition?.conditions ?? []

  // eslint-disable-next-line @typescript-eslint/no-shadow
  conditions.forEach((condition) => {
    const c = condition as SimpleConditionDefinition
    const fieldDef = getFieldDefIncludeExternal(viewModel, c.field, baseMetadata)
    const fieldValue = fieldDef.getFieldValue()
    fieldValue.value = c.value

    if (c.fieldValue) fieldValue.mapField(c.fieldValue, fieldDef)

    res.push({
      id: c.id !== '' ? c.id : crypto.randomUUID(),
      column: c.field,
      operatorType: OperatorType[c.operator],
      node: createFormNodeForFilter(fieldDef, viewModel.name, c.value ? fieldValue : null),
    })
  })

  return res
}
